import React from 'react'
import PropTypes from 'prop-types'
import styles from './WidgetSlatePlugin.scss'
import {hasWidgetByTypeAndKey} from './WidgetSlatePluginContainer'
import WidgetModal from './WidgetModal'
import { FaTrash } from 'react-icons/lib/fa'
import EditorTooltip from '../EditorTooltip'
import { Button, ButtonGroup } from 'reactstrap'

class WidgetNode extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      isHovered: false,
      isOpenModal: props.node.data.get('openModal')
    }
  }

  modal = (isOpenModal) => {
    this.setState({ isOpenModal })
  }

  onRemove = () => {
    this.props.editor.onChange(this.props.state
      .transform()
      .removeNodeByKey(this.props.node.key)
      .apply()
    )
  }

  onEdit = () => {
    this.modal(true)
  }

  render () {
    const { attributes, state, node, title, editor: { onChange } } = this.props
    const { isOpenModal } = this.state
    const isVideo = node.type === 'Video'
    const hasModal = isVideo
    const data = node.data.toJS()
    const target = 'WidgetNode' + node.type + node.key
    const isOpen = hasWidgetByTypeAndKey(state, node.type, node.key)
    const isOpenAndFocused = isOpen && state.isFocused
    const tooltipProps = {
      state,
      isOpen,
      target
    }
    return <div {...attributes}
      id={target}
      className={styles.WidgetNode + ' ' + (isOpenAndFocused ? styles.focused : '')}>
      <div className={styles.title}>
        {isVideo && '📽 '}
        {title}
        {
          isVideo &&
          <div>
            <a href={data.url} target='_blank'>{data.url}</a>
          </div>
        }
      </div>

      <EditorTooltip {...tooltipProps} placement='top' className={styles.WidgetNodeTooltip}>
        <ButtonGroup>
          {
            hasModal &&
            <Button onClick={this.onEdit}>Edit</Button>
          }
          <Button color='danger' onClick={this.onRemove}><FaTrash /></Button>
        </ButtonGroup>
      </EditorTooltip>
      {
        hasModal &&
        <WidgetModal
          isOpen={isOpenModal}
          node={node}
          state={state}
          onChange={onChange}
          changeModalState={this.modal}
          />
      }
    </div>
  }
}

WidgetNode.propTypes = {
  title: PropTypes.string,
  editor: PropTypes.object,
  attributes: PropTypes.object,
  state: PropTypes.object,
  node: PropTypes.object
}

export default WidgetNode



// WEBPACK FOOTER //
// ./src/components/WidgetSlatePlugin/WidgetNode.js